import { Alert, Button, useToast } from '@dreamtree-org/twreact-ui';
import { SectionCard, QueryState, StatusBadge } from '@/components';
import { useQuery, useMutation } from '@/lib/useQuery';
import { formatDate } from '@/lib/format';
import Can from '@rbac/Can';

/** SELL-08 Policies — versioned platform policies the store must accept (real since D7). */
export default function PoliciesTab() {
  const { toast } = useToast();
  const q = useQuery('merchantPolicies', {}, { select: (r) => r.data });
  const accept = useMutation('merchantPolicyAccept');

  const doAccept = async (p) => {
    try {
      await accept.run({ key: p.key, version: p.version });
      toast.success('Policy accepted', `${p.title} ${p.version}`);
      q.reload();
    } catch { /* accept.error */ }
  };

  return (
    <div className="space-y-4">
      <QueryState query={q}>
        {(rows) => (
          <div className="grid gap-4 lg:grid-cols-2">
            {rows.map((p) => {
              const current = p.accepted_version === p.version;
              return (
                <SectionCard
                  key={p.key}
                  title={`${p.title} · ${p.version}`}
                  actions={<StatusBadge status={current ? 'approved' : 'pending'} label={current ? 'accepted' : 'action needed'} />}
                >
                  {p.stale_terms ? (
                    <Alert variant="warning" title="Review this text">
                      This text states a day or month count that conflicts with the marketplace return, DOA and warranty terms that shoppers see at checkout. Update it so it does not promise different windows.
                    </Alert>
                  ) : null}
                  <p className="text-sm opacity-80">{p.body}</p>
                  <p className="text-xs opacity-60">
                    {p.accepted_version ? `You accepted ${p.accepted_version} on ${formatDate(p.accepted_at)}.` : 'Not accepted yet.'}
                    {p.accepted_by ? ` By ${p.accepted_by}.` : ''}
                    {!current && p.required ? ' Required: accept the current version to stay compliant with the marketplace.' : ''}
                  </p>
                  {!current ? (
                    <Can module="store" action="policies">
                      <Button size="sm" onClick={() => doAccept(p)} loading={accept.loading}>Accept {p.version}</Button>
                    </Can>
                  ) : null}
                </SectionCard>
              );
            })}
          </div>
        )}
      </QueryState>
    </div>
  );
}
